import apiClient from './apiClient';

/**
 * Event Vote API functions
 */
export const eventVoteApi = {
  /**
   * Get event vote data
   * @param eventId - The event ID
   * @param userId - Optional user ID for admin viewing as user
   */
  getEventVote: async (eventId: string, userId?: string) => {
    try {
      console.log('Fetching event vote data from API...');
      const url = userId 
        ? `/api/v2/web/events/${eventId}/vote?user_id=${userId}`
        : `/api/v2/web/events/${eventId}/vote`;
      const response = await apiClient.get(url);
      console.log('Event vote API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getEventVote:', error);
      throw error;
    }
  },

  /**
   * Save event votes
   * @param eventId - The event ID
   * @param votes - Array of votes with selected_user_id and rank
   * @param targetUserId - Optional user ID for admin saving on behalf of user
   */
  saveEventVotes: async (eventId: string, votes: Array<{ selected_user_id: string; rank: number }>, targetUserId?: string) => {
    try {
      console.log('Saving event votes...');
      const payload: any = { votes };
      if (targetUserId) {
        payload.user_id = targetUserId;
      }
      const response = await apiClient.post(`/api/v2/web/events/${eventId}/vote`, payload);
      console.log('Save votes API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in saveEventVotes:', error);
      throw error;
    }
  }
};
